import { CLEAR_AIRPORT, SET_AIRPORT } from "../actions/airport";

const initialState = [
    { value: "ABD", label: "Abadan" },
    { value: "AEU", label: "Abu Musa Island" },
    { value: "AWZ", label: "Ahvaz" },
    { value: "AJK", label: "Arak" },
    { value: "ADU", label: "Ardabil" },
    { value: "YEH", label: "Asalouyeh (Asalouyeh Airport)" },
    { value: "PGU", label: "Asalouyeh (Persian Gulf Airport)" },
    { value: "BBL", label: "Babolsar" },
    { value: "IAQ", label: "Bahregan" },
    { value: "BXR", label: "Bam" },
    { value: "BND", label: "Bandar Abbas" },
    { value: "BDH", label: "Bandar Lengeh" },
    { value: "XBJ", label: "Birjand" },
    { value: "BJB", label: "Bojnord" },
    { value: "BUZ", label: "Bushehr" },
    { value: "ZBR", label: "Chabahar" },
    { value: "DEF", label: "Dezful" },
    { value: "FAZ", label: "Fasa" },
    { value: "GCH", label: "Gachsaran" },
    { value: "GBT", label: "Gorgan" },
    { value: "HDM", label: "Hamadan" },
    { value: "IIL", label: "Ilam" },
    { value: "IHR", label: "Iranshahr" },
    { value: "IFN", label: "Isfahan | Esfahan" },
    { value: "JAR", label: "Jahrom" },
    { value: "JSK", label: "Jask" },
    { value: "JYR", label: "Jiroft" },
    { value: "KLM", label: "Kalaleh" },
    { value: "KNR", label: "Kangan" },
    { value: "PYK", label: "Karaj" },
    { value: "KKS", label: "Kashan" },
    { value: "KER", label: "Kerman" },
    { value: "KSH", label: "Kermanshah" },
    { value: "KHA", label: "Khaneh" },
    { value: "KHK", label: "Kharg Island" },
    { value: "KHD", label: "Khorramabad" },
    { value: "KHY", label: "Khoy" },
    { value: "KIH", label: "Kish Island" },
    { value: "LFM", label: "Lamerd" },
    { value: "LRR", label: "Larestan" },
    { value: "LVP", label: "Lavan Island" },
    { value: "MRX", label: "Mahshahr" },
    { value: "ACP", label: "Maragheh (Sahand)" },
    { value: "MHD", label: "Mashhad" },
    { value: "NSH", label: "Noshahr" },
    { value: "PFQ", label: "Parsabad" },
    { value: "GZW", label: "Qazvin (Ghazvin)" },
    { value: "GSM", label: "Qeshm Island" },
    { value: "RJN", label: "Rafsanjan" },
    { value: "RZR", label: "Ramsar / Tonekabon" },
    { value: "RAS", label: "Rasht" },
    { value: "AFZ", label: "Sabzevar" },
    { value: "SDG", label: "Sanandaj" },
    { value: "CKT", label: "Sarakhs" },
    { value: "SRY", label: "Sari" },
    { value: "CQD", label: "Shahrekord" },
    { value: "RUD", label: "Shahrood" },
    { value: "SYZ", label: "Shiraz" },
    { value: "SYJ", label: "Sirjan" },
    { value: "SXI", label: "Sirri Island" },
    { value: "TCX", label: "Tabas" },
    { value: "TBZ", label: "Tabriz" },
    { value: "IKA", label: "Tehran (Imam Khomeini International Airport)" },
    { value: "THR", label: "Tehran (Mehrabad International Airport)" },
    { value: "OMH", label: "Urmia" },
    { value: "YES", label: "Yasuj" },
    { value: "AZD", label: "Yazd" },
    { value: "ACZ", label: "Zabol" },
    { value: "ZAH", label: "Zahedan" },
    { value: "JWN", label: "Zanjan" }
];



export default function airports(state = initialState, action = {}) {
    switch (action.type) {
        case SET_AIRPORT:
            const { airport } = action;
            return airport;
        case CLEAR_AIRPORT:
            return initialState;
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/redux/reducers/airportsReducer.js